import styled from 'styled-components';
import type { SplashPageViewModel } from '@lib/page-data/splash.map';
import type { Locale } from '@lib/locale';
import type { PageInjectedProps } from '../Pages/Page';

import MaxWidthLayout from '../../../templates/MaxWidthLayout';
import LayoutCollectionView from '../LayoutCollectionView/LayoutCollectionView';
import {
  removeOfferById,
  saveOffer,
} from '../../../../lib/user';
import {
  OFFERS,
  GRID,
} from '../../../../lib/constants';
import OfferCard from '../Offer/OfferCard';
import { StyledHtmlRenderer } from '../shared/StyledHtmlRenderer';

type Props = {
  splashPageData: SplashPageViewModel['splashPage'];
  locale?: Locale;
  userData: PageInjectedProps['userData'];
  pageStateModifiers?: PageInjectedProps['pageStateModifiers'];
};

const PageBodyDiv = styled(StyledHtmlRenderer)`
  margin-bottom: ${(p) => p.theme.unit(3)};
`;

const SplashPageContent = (props: Props) => {
  const {
    splashPageData = {},
    pageStateModifiers = {},
    userData,
    locale = 'en',
  } = props;

  const splashContent = 'splashContent' in splashPageData ? splashPageData.splashContent ?? '' : '';

  const offers: unknown[] = Array.isArray(userData.offers) ? userData.offers : [];
  const favOffersIds = offers.flatMap((offer) => (
    typeof offer === 'object' && offer !== null && 'id' in offer ? [offer.id] : []
  ));

  const pageBodyRender = (
    <PageBodyDiv dangerouslySetInnerHTML={{
      __html: splashContent,
    }}
    />
  );

  const offerCardGridRender = (
    <LayoutCollectionView
      favItemIds={favOffersIds}
      items={'offers' in splashPageData ? splashPageData.offers : undefined}
      Comp={OfferCard}
      itemType={OFFERS}
      viewType={GRID}
      pageStateModifiers={pageStateModifiers}
      saveItemHandler={saveOffer}
      removeItemHandler={removeOfferById}
      locale={locale}
      showDisplayName
    />
  );

  return (
    <MaxWidthLayout>
      {pageBodyRender}
      {offerCardGridRender}
    </MaxWidthLayout>
  );
};

export default SplashPageContent;
